import type { CmsPage } from '@webapp/landing/src/resources/api';

export const filterBlogContent = (data: Array<CmsPage>) => {
    return data?.length > 1 ? data.filter((item) => item.parentId === '115') : data;
};
